import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-white">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gamo-light-gray select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10 max-w-md">
        <div className="w-14 h-14 flex items-center justify-center mx-auto mb-6 rounded-full bg-gamo-green/10 text-gamo-green">
          <i className="ri-error-warning-line text-2xl"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-bold text-gamo-black mt-2 mb-3">
          ページが見つかりません
        </h1>
        <p className="text-base text-gamo-medium-gray font-mono break-all">
          {location.pathname}
        </p>
        <p className="mt-4 text-sm md:text-base text-gamo-dark-gray leading-relaxed">
          お探しのページは削除されたか、URLが変更された可能性があります。
          トップページから目的の情報をお探しください。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <a
            href="/"
            className="inline-flex items-center gap-2 bg-gamo-green text-white text-sm font-medium px-6 py-3 rounded-full transition-all duration-300 hover:bg-gamo-green-dark whitespace-nowrap"
          >
            <i className="ri-home-line text-sm"></i>
            <span>トップページに戻る</span>
          </a>
          <a
            href="/links"
            className="inline-flex items-center gap-2 border border-gamo-border-gray text-gamo-dark-gray text-sm font-medium px-6 py-3 rounded-full transition-all duration-300 hover:bg-gamo-light-gray whitespace-nowrap"
          >
            <i className="ri-building-line text-sm"></i>
            <span>グループ校・企業一覧</span>
          </a>
        </div>
      </div>
    </div>
  );
}